<template>
  <v-container fluid grid-list-md>

    <v-row style="margin-left: 0.5px;">
      <div class="title">{{ $tc('label.linha_investimento', 2) }}</div>
      <v-tooltip v-if="!edicao" bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon
                 id="rateio-botao-importar"
                 v-on="on"
                 @click="importarSpreadsheet">
            <v-icon>cloud_upload</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('label.importar_conteudo') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon
            id="rateio-botao-exportar"
            v-on="on"
            @click="exportarSpreadsheet">
            <v-icon>get_app</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('label.exportar_conteudo') }}</span>
      </v-tooltip>
    </v-row>
    <br>
    <v-row style="margin-left: 0.1px; margin-right: 0.1px;">
      <spreadsheet
        ref="spreadsheet"
        selectRange="A2"
        v-if="planilhaPronta"
        :toolbar="false"
        :tamanhoColunas="tamanhoColunas"
        :sheetsbar="false"
        :rows="qtdeLinhas"
        :data="datasource"
        :colunas="colunas"
        :estilos="estilos"
        :frozenRows="1"
        :autocomplete="true"/>
    </v-row>

    <upload-file-form
      ref="uploadArquivo"
      :title="$t('label.fazer_nova_importacao')"
      :url="uploadUrl"
      :accepted-file-types="acceptedFileTypes"
      :auto-process-queue="false"
      @UploadArquivo__success="uploadSuccess"
      @UploadArquivo__error="uploadError"
      @UPLOADFILE_SENDING="enviandoArquivo"
    />
  </v-container>
</template>
<script>
import Spreadsheet from '../../../shared-components/spreadsheet/Spreadsheet';
import { toColumnName } from '../../../common/functions/helpers';
import InputNumber from '../../../shared-components/inputs/InputNumber';
import { basePath } from '../../../common/resources/importacoes';
import UploadFileForm from '../../../shared-components/upload/UploadFileForm';

export default {
  components: {
    Spreadsheet,
    InputNumber,
    UploadFileForm,
  },
  props: {
    edicao: Boolean,
    somenteLeitura: Boolean,
    ajusteVerba: {
      type: Object,
      required: true,
    },
  },
  computed: {
    linhasInvestimento() {
      return this.ajusteVerba.linhas;
    },
    isRateioDivisao() {
      return this.ajusteVerba.linhas
        && this.ajusteVerba.linhas.length
        && this.ajusteVerba.linhas[0].divisao !== undefined;
    },
    colunasBase() {
      const colunasPadrao = [
        {
          field: 'descricao',
          title: `${this.$tc('label.linha', 1)}`,
        },
        {
          field: 'tipoInvestimento',
          title: `${this.$tc('label.tipo_de_investimento', 1)}`,
        },
      ];

      if (this.isRateioDivisao) {
        colunasPadrao.push(
          {
            field: 'divisao',
            title: `${this.$tc('label.divisao', 1)}`,
          },
        );
      } else {
        colunasPadrao.push(
          {
            field: 'holding',
            title: `${this.$tc('label.holding', 1)}`,
          },
        );
      }
      return colunasPadrao;
    },
    acceptedFileTypes() {
      return '.xlsx,.xls';
    },
  },
  data() {
    return {
      ajusteVerbaResource: this.$api.ajusteVerbaReducaoMassiva(this.$resource),
      extensaoResource: this.$api.extensao(this.$resource),

      planilhaPronta: false,

      datasource: [],
      originalDatasource: [],
      colunas: [],
      tamanhoColunas: [],
      estilos: [],
      formulas: [],
      qtdeLinhas: 50,

      uploadUrl: `${basePath}importacao-ajuste-verba`,

      estiloTitulo: {
        textAlign: 'center',
        bold: true,
        enable: false,
        background: this.$vuetify.theme.currentTheme.primary,
        color: 'rgb(255,255,255)',
      },
      estiloSomenteLeituraTexto: { enable: false, color: 'rgb(0,0,0)' },
      estiloSomenteLeituraNro: { enable: false, background: 'rgb(191,191,191)', color: 'rgb(0,0,0)' },
    };
  },
  methods: {
    refazerSpreadsheet() {
      this.planilhaPronta = false;
      setTimeout(() => this.iniciaPlanilha());
    },
    importarSpreadsheet() {
      if (this.$refs.uploadArquivo) {
        this.$refs.uploadArquivo.open();
      } else {
        console.warn('Componente de upload não está disponível ainda');
      }
    },
    enviandoArquivo(data, xhr, formData) {
      const { tipoVerba, orcamento, periodoOrcamentario } = this.ajusteVerba;

      const parametros = {
        idTipoVerba: tipoVerba.id,
        idOrcamento: orcamento.id,
        periodoOrcamentario: periodoOrcamentario.id,
      };

      formData.append('parametros', JSON.stringify(parametros));
    },
    uploadSuccess(file, response) {
      const { dadosajusteverba, inderros } = response;
      try {
        if (inderros) {
          this.$toast(this.$t('message.importacao_com_pendencias'), 'warning');
        } else {
          this.$toast(this.$t('message.upload_sucesso'), 'success');
        }

        this.processarDadosImportados(dadosajusteverba);

        if (this.$refs.uploadArquivo) this.$refs.uploadArquivo.close();
      } catch (e) {
        console.error('Erro ao tratar sucesso do upload:', e);
      }
    },
    uploadError(file, msg) {
      console.error('Erro no upload:', msg);
      this.$toast(this.$t('message.upload_falha'), 'error');
      if (this.$refs.uploadArquivo) this.$refs.uploadArquivo.close();
    },
    processarDadosImportados(response) {
      try {
        const dados = this.normalizarRetornoImportacao(response);
        if (!Array.isArray(dados) || dados.length === 0) {
          this.$toast(this.$t('message.dados_invalidos'), 'error');
          return;
        }

        const linhasNormalizadas = dados.map((linha) => {
          const valorReducao = linha.valorReducaoPara || linha.valor_reducao_para;
          const tipoAjuste = linha.tipoAjuste || linha.tipo_ajuste;
          return {
            descricao: linha.descricao || '',
            tipoInvestimento: linha.tipoInvestimento || '',
            divisao: linha.divisao || undefined,
            holding: linha.holding || (linha.divisao !== undefined ? '' : ''),
            valorPeriodo: parseFloat(valorReducao != null ? valorReducao : (linha.valorPeriodo || 0)) || 0,
            planejado: parseFloat(linha.planejado || 0) || 0,
            saldo: parseFloat(linha.saldo || 0) || 0,
            tipoAjuste: tipoAjuste || '',
            idLinhaInvestimento: linha.idLinhaInvestimento || undefined,
          };
        });

        this.ajusteVerba.linhas = linhasNormalizadas;
        this.datasource = linhasNormalizadas;
        this.originalDatasource = JSON.parse(JSON.stringify(linhasNormalizadas));
        this.qtdeLinhas = linhasNormalizadas.length + 1;

        this.refazerSpreadsheet();

        this.$emit('dados-importados', linhasNormalizadas);
      } catch (error) {
        console.error('Erro ao processar dados importados:', error);
        this.$toast(this.$t('message.erro_processamento_arquivo'), 'error');
      }
    },

    normalizarRetornoImportacao(response) {
      if (Array.isArray(response)) return response;
      if (response && Array.isArray(response.data)) return response.data;
      if (response && Array.isArray(response.dadosAjusteVerba)) return response.dadosAjusteVerba;
      if (response && Array.isArray(response.dados_ajuste_verba)) return response.dados_ajuste_verba;
      try {
        if (typeof response === 'string') {
          const parsed = JSON.parse(response);
          if (Array.isArray(parsed)) return parsed;
          if (Array.isArray(parsed.data)) return parsed.data;
          if (Array.isArray(parsed.dadosAjusteVerba)) return parsed.dadosAjusteVerba;
          if (Array.isArray(parsed.dados_ajuste_verba)) return parsed.dados_ajuste_verba;
        }
      } catch (e) {
        // ignore
      }
      return null;
    },
    exportarSpreadsheet() {
      this.$refs.spreadsheet.exportarExcel();
    },
    getCelulaEntidade(entidade) {
      switch (entidade) {
        case 'descricao':
          return 'A';
        case 'tipo_investimento':
          return 'B';
        case 'divisao':
          return 'C';
        case 'holding':
          return 'C';
        case 'chave':
          return 'B';
        default:
          return 'D';
      }
    },
    iniciaPlanilha() {
      this.montarColunas();
      this.preencheDados();
      this.aplicaEstiloColunas();
      this.planilhaPronta = true;
    },
    preencheDados() {
      this.datasource = [...this.linhasInvestimento];
      this.originalDatasource = JSON.parse(JSON.stringify(this.datasource));
      this.qtdeLinhas = this.linhasInvestimento ? (this.linhasInvestimento.length + 1) : 0;
    },
    colunaPeriodo() {
      return {
        field: 'valorPeriodo',
        title: `${this.$tc('label.valor_reducao_para', 1)} ${this.ajusteVerba.periodoOrcamentario.descricao}`,
      };
    },
    colunasCC() {
      return [
        {
          field: 'planejado',
          title: this.$tc('label.valor_planejado'),
        },
        {
          field: 'saldo',
          title: this.$tc('label.saldo'),
        },
      ];
    },
    colunasAjuste() {
      return [
        {
          field: 'tipoAjuste',
          title: this.$tc('label.tipo_de_ajuste'),
        },
      ];
    },
    montarColunas() {
      this.colunas = [
        ...this.colunasBase,
        this.colunaPeriodo(),
        ...this.colunasCC(),
        ...this.colunasAjuste(),
      ];
    },
    aplicaEstiloColunas() {
      this.estilos = [];
      this.formulas = [];
      this.aplicaTamanhoColunas();
      this.aplicaEstiloCabecalho();
      this.aplicaEstiloDesabilitados();
      this.aplicaEstiloCampoNumerico();
      // this.aplicaEstiloUltimaLinha();
    },
    aplicaTamanhoColunas() {
      this.tamanhoColunas = [
        { width: 300 },
        { width: 200 },
        { width: 250 },
        { width: 300 },
        { width: 200 },
        { width: 200 },
        { width: 200 },
      ];
    },
    aplicaEstiloCabecalho() {
      const letraInicial = toColumnName(0);
      const letraFinal = toColumnName(this.colunas.length - 1);
      this.estilos.push({ range: `${letraInicial}1:${letraFinal}1`, metodos: this.estiloTitulo });
    },
    aplicaEstiloDesabilitados() {
      if (!this.somenteLeitura) {
        this.estilos.push(
          {
            range: `A2:C${this.datasource.length + 1}`,
            metodos: this.estiloSomenteLeituraTexto,
          },
          {
            range: `E2:F${this.qtdeLinhas}`,
            metodos: this.estiloSomenteLeituraNro,
          },
        );
      } else {
        this.estilos.push(
          {
            range: `A2:D${this.qtdeLinhas}`,
            metodos: this.estiloSomenteLeituraTexto,
          },
          {
            range: `E2:F${this.qtdeLinhas}`,
            metodos: this.estiloSomenteLeituraNro,
          },
        );
      }
    },
    aplicaEstiloUltimaLinha() {
      const letraInicial = toColumnName(0),
        letraFinal = toColumnName(this.colunas.length - 1),
        numeroLinha = this.qtdeLinhas;

      this.estilos.push({
        range: `${letraInicial}${numeroLinha}:${letraFinal}${numeroLinha}`,
        metodos: this.estiloSomenteLeituraTexto,
      });
    },
    aplicaEstiloCampoNumerico() {
      const max = 9999999999.99,
        min = 0.00;

      this.estilos.push({
        range: `D2:F${this.qtdeLinhas}`,
        metodos: { format: '[>=0][BLACK]###,##0.00;[RED]###,##0.00' },
      });
      this.formulas.push({
        range: `D2:F${this.qtdeLinhas}`,
        metodos: {
          validation: {
            allowNulls: true,
            comparerType: 'between',
            from: min,
            to: max,
            dataType: 'number',
            type: 'reject',
            messageTemplate:
              this.$t('message.intervalo_numerico', { min, max }),
            titleTemplate: this.$tc('title.erro', 1),
          },
        },
      });
    },
    validaAjusteVerba(datasource) {
      const devolucao = this.$t('errors.reducao.tipo_ajuste_devolucao').toLowerCase();
      const ordemCompra = this.$t('errors.reducao.tipo_ajuste_ordem_compra').toLowerCase();
      const hasInvalid = datasource.some((r) => {
        const tipo = (r.tipoAjuste || '').toString().toLowerCase().trim();
        if (!tipo) return false;
        return tipo !== devolucao && tipo !== ordemCompra;
      });
      return !hasInvalid;
    },
    validaPreenchimentoParcial(datasource) {
      const hasInvalid = datasource.some((r, index) => {
        const original = this.originalDatasource[index] || {};
        const originalValor = Number(original.valorPeriodo || 0);
        const currentValor = Number(r.valorPeriodo || 0);
        const originalTipo = (original.tipoAjuste || '').toString().trim();
        const currentTipo = (r.tipoAjuste || '').toString().trim();
        const houveMudanca = originalValor !== currentValor || originalTipo !== currentTipo;
        const tipoPreenchido = currentTipo !== '';
        return houveMudanca && !tipoPreenchido;
      });
      return !hasInvalid;
    },
    valida() {
      const datasource = this.$refs.spreadsheet.getDataSource();

      if (!this.validaPreenchimentoParcial(datasource)) {
        this.$toast(this.$t('errors.reducao.campos_condicionais'));
        return false;
      }

      let valido = datasource
        .map((r) => r.valorPeriodo || 0)
        .reduce((a, b) => a + b, 0) > 0;

      if (!valido) {
        this.$toast(this.$t('errors.reducao.valor_reduzir_menor_zero'));
        return valido;
      }

      datasource.forEach((r) => {
        if (r.valorPeriodo > 0 && r.saldo < r.valorPeriodo) {
          valido = false;
        }
      });

      if (!valido) {
        this.$toast(this.$t('errors.reducao.valor_reduzir_maior_saldo'));
      }

      if (!this.validaAjusteVerba(datasource)) {
        this.$toast(this.$t('errors.reducao.tipo_ajuste_invalido'));
        return false;
      }

      return valido;
    },
    linhasValidas() {
      const datasource = this.$refs.spreadsheet.getDataSource();
      // Filtra as linhas que possuem algo preenchido
      return datasource
        .map((r) => JSON.parse(JSON.stringify(r)))
        .filter((r) => Object.keys(r).filter((k) => !!r[k]).length > 0);
    },
  },
  mounted() {
    this.iniciaPlanilha();
  },
};
</script>
